const useCheckbox = (className, error, style, global, disabled) => {
  const fullClassAttribute = [style.Checkbox, (error ? global.Error : global.BaseInputBox), (className || '')].join(' ');
  
  const isDisabled = (disabled === true);

  return {fullClassAttribute, isDisabled}
};

export default useCheckbox;